document.addEventListener('DOMContentLoaded', () => {

  // ========== BRAND MARQUEE ANIMATION ==========
  (function () {
    function updateTrack(track) {
      var totalWidth = track.scrollWidth;
      if (!totalWidth) return;
      var speed = parseFloat(getComputedStyle(track).getPropertyValue('--brand-speed')) || 84;
      var duration = (totalWidth / 2) / speed;
      track.style.setProperty('--brand-duration', duration + 's');
    }

    function updateAll() {
      document.querySelectorAll('.brand-track').forEach(updateTrack);
    }

    var resizeTimeout;
    function onResize() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateAll, 150);
    }

    requestAnimationFrame(updateAll);
    window.addEventListener('resize', onResize);
  })();

  // ========== HERO SLIDER ==========
  // ALTIJD doordraaien - geen pauze bij hover of tab switch
  const heroSlider = document.getElementById('heroSlider');
  if (heroSlider) {
    const slides = heroSlider.querySelectorAll('.hero-slide');
    const textSlides = document.querySelectorAll('.hero-text-slide');
    const dots = document.querySelectorAll('.slider-dot');
    const imageDots = document.querySelectorAll('.hero-image-dot');
    let currentSlide = 0;
    let slideInterval;
    const SLIDE_DURATION = 7000; // 7 seconds - langer interval tussen slides

    // Lazy-load slide images: swap data-src → src and data-srcset → srcset
    function ensureSlideImagesLoaded(idx) {
      const slide = slides[idx];
      if (!slide) return;
      slide.querySelectorAll('source[data-srcset]').forEach(source => {
        source.srcset = source.dataset.srcset;
        source.removeAttribute('data-srcset');
      });
      slide.querySelectorAll('img[data-srcset]').forEach(img => {
        img.srcset = img.dataset.srcset;
        img.removeAttribute('data-srcset');
      });
      slide.querySelectorAll('img[data-src]').forEach(img => {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      });
    }

    function showSlide(index) {
      // Ensure current + next slide images are loaded
      ensureSlideImagesLoaded(index);
      ensureSlideImagesLoaded((index + 1) % slides.length);

      // Remove active classes from all slides
      slides.forEach(slide => {
        slide.classList.remove('active');
      });

      // Update text slides
      textSlides.forEach(slide => {
        slide.classList.remove('active');
      });
      if (textSlides[index]) {
        textSlides[index].classList.add('active');
      }

      // Update text panel dots
      dots.forEach(dot => {
        dot.classList.remove('active');
        const bar = dot.querySelector('.progress-bar');
        if (bar) {
          bar.style.transition = 'none';
          bar.style.width = '0';
        }
      });

      // Update image panel carousel indicators
      imageDots.forEach(dot => {
        dot.classList.remove('active');
        // Reset ring animation
        const ring = dot.querySelector('.ring-progress');
        if (ring) {
          ring.style.animation = 'none';
          ring.offsetHeight; // Force reflow
        }
      });

      // Add active class to current slide
      slides[index].classList.add('active');
      if (dots[index]) {
        dots[index].classList.add('active');
        // Start progress bar animation
        const activeBar = dots[index].querySelector('.progress-bar');
        if (activeBar) {
          void activeBar.offsetWidth;
          setTimeout(() => {
            activeBar.style.transition = `width ${SLIDE_DURATION}ms linear`;
            activeBar.style.width = '100%';
          }, 50);
        }
      }

      if (imageDots[index]) {
        imageDots[index].classList.add('active');
        // Restart ring animation
        const ring = imageDots[index].querySelector('.ring-progress');
        if (ring) {
          ring.style.animation = `ringProgress ${SLIDE_DURATION}ms linear forwards`;
        }
      }

      currentSlide = index;
    }

    function nextSlide() {
      const nextIndex = (currentSlide + 1) % slides.length;
      showSlide(nextIndex);
    }

    // Start continuous slider - NOOIT stoppen
    function startSlider() {
      // Clear any existing interval
      if (slideInterval) {
        clearInterval(slideInterval);
      }
      // Set interval that ALWAYS runs
      slideInterval = setInterval(nextSlide, SLIDE_DURATION);
    }

    // Dot navigation click handlers (text panel) - slider blijft doordraaien
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        if (index !== currentSlide) {
          showSlide(index);
          // Herstart interval vanaf nieuwe slide
          startSlider();
        }
      });
    });

    // Image carousel indicator click handlers
    imageDots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        if (index !== currentSlide) {
          showSlide(index);
          // Herstart interval vanaf nieuwe slide
          startSlider();
        }
      });
    });

    // GEEN pause on hover - slider draait ALTIJD door
    // GEEN pause bij tab switch - slider draait ALTIJD door

    // Start slider
    showSlide(0);
    startSlider();

    // Touch/swipe support for mobile - ALLEEN bij duidelijke swipe
    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;
    let touchEndY = 0;
    let isSwiping = false;

    heroSlider.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
      isSwiping = false;
    }, { passive: true });

    heroSlider.addEventListener('touchmove', (e) => {
      // Check if user is scrolling vertically or swiping horizontally
      const currentX = e.changedTouches[0].screenX;
      const currentY = e.changedTouches[0].screenY;
      const diffX = Math.abs(currentX - touchStartX);
      const diffY = Math.abs(currentY - touchStartY);

      // Als horizontale beweging > verticale beweging = swipe
      if (diffX > diffY && diffX > 30) {
        isSwiping = true;
      }
    }, { passive: true });

    heroSlider.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      touchEndY = e.changedTouches[0].screenY;

      // ALLEEN wisselen als er daadwerkelijk geswiped werd
      if (isSwiping) {
        handleSwipe();
      }
      // Anders: doe niets, laat timer gewoon doorlopen
    });

    function prevSlide() {
      const prevIndex = (currentSlide - 1 + slides.length) % slides.length;
      showSlide(prevIndex);
      startSlider(); // Herstart interval
    }

    function handleSwipe() {
      const swipeThreshold = 80; // Verhoog threshold voor duidelijkere swipe
      const diff = touchStartX - touchEndX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          // Swipe left - next slide
          nextSlide();
          startSlider(); // Herstart interval
        } else {
          // Swipe right - previous slide
          prevSlide();
        }
      }
    }
  }

  // ========== VIDEO LAZY LOADING (HTW gecombineerde sectie) ==========
  const htwVideo = document.getElementById('htwVideo');
  if (htwVideo) {
    const video = htwVideo.querySelector('video');

    if (video && 'IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const videoSrc = video.dataset.src;
            if (videoSrc && !video.src) {
              const source = document.createElement('source');
              source.src = videoSrc;
              source.type = 'video/mp4';
              video.appendChild(source);

              // Wait until video has buffered enough to play
              video.addEventListener('canplay', function() {
                video.play().catch(e => {
                  console.log('Video autoplay failed:', e);
                });
              }, { once: true });

              video.load();
              videoObserver.unobserve(entry.target);
            }
          }
        });
      }, {
        rootMargin: '0px 0px 150px 0px' // pas laden vlak voor in beeld (600px liet hem al bij het openen laden: 683 KB)
      });

      videoObserver.observe(htwVideo);
    } else {
      if (video && video.dataset.src) {
        const source = document.createElement('source');
        source.src = video.dataset.src;
        source.type = 'video/mp4';
        video.appendChild(source);
        video.load();
        video.autoplay = true;
      }
    }
  }

  // ========== FEATURES CAROUSEL - VERWIJDERD ==========
  // Nu onderdeel van de gecombineerde HTW sectie (geen carousel meer)

  // ========== FAQ ACCORDION ==========
  const faqItems = document.querySelectorAll('.faq-item');

  // Na het openen: andere items klappen dicht (0,4s transitie). Staat het geopende item
  // daardoor buiten beeld (vooral mobiel, als een item erboven dichtging), scroll het dan
  // netjes onder de sticky header. Alleen scrollen als het echt nodig is.
  function smFaqKeepInView(item) {
    setTimeout(function () {
      try {
        var r = item.getBoundingClientRect();
        var top = 96; // hoogte sticky header + marge
        if (r.top < top || r.top > window.innerHeight - 120) {
          window.scrollTo({ top: window.scrollY + r.top - top, behavior: 'smooth' });
        }
      } catch (e) {}
    }, 420);
  }
  
  faqItems.forEach(item => {
    const question = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');
    
    if (question && answer) {
      question.addEventListener('click', (e) => {
        e.preventDefault();
        const isOpen = item.classList.contains('open');
        
        // Close all other FAQ items
        faqItems.forEach(otherItem => {
          if (otherItem !== item) {
            otherItem.classList.remove('open');
            const otherAnswer = otherItem.querySelector('.faq-answer');
            if (otherAnswer) {
              otherAnswer.style.maxHeight = '0';
            }
          }
        });
        
        // Toggle current item
        if (!isOpen) {
          item.classList.add('open');
          answer.style.maxHeight = answer.scrollHeight + 'px';
          smFaqKeepInView(item);
        } else {
          item.classList.remove('open');
          answer.style.maxHeight = '0';
        }
      });
    }
  });

  // ========== SCROLL REVEAL ANIMATION - UITGESCHAKELD VOOR CONVERSIE ==========
  // Content is nu direct zichtbaar - geen scroll-triggered animaties meer
  // Dit verbetert de conversie door immediate value clarity

  // ========== PARALLAX EFFECT (UITGESCHAKELD - veroorzaakte lege ruimte bij scrollen) ==========
  // Parallax verwijderd omdat het een gat creëerde onder de hero afbeeldingen

  // ========== SMOOTH SCROLL FOR ANCHOR LINKS ==========
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href && href !== '#') {
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          const headerOffset = 80;
          const elementPosition = target.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }
    });
  });

}); // Sluit de hoofd DOMContentLoaded handler

// ========== MOBILE STICKY CTA (altijd zichtbaar onderaan op mobiel) ==========
(function () {
  const cta = document.getElementById('mobile-sticky-cta');
  if (!cta || window.innerWidth > 1024) return;

  // Direct zichtbaar maken
  cta.classList.add('visible');

  // Verberg CTA bij soft keyboard (best effort)
  let lastH = window.innerHeight;
  window.addEventListener('resize', () => {
    const kbOpen = window.innerHeight < lastH - 120;
    if (kbOpen) {
      cta.classList.add('keyboard-open');
    } else {
      cta.classList.remove('keyboard-open');
    }
    lastH = window.innerHeight;
  });
})();

// ========== SHOWCASE CAROUSEL (Luxe tot in detail - Mobile) ==========
document.addEventListener('DOMContentLoaded', () => {
  const showcaseCarousel = document.getElementById('showcaseCarousel');
  if (showcaseCarousel && window.innerWidth <= 768) {
    const track = showcaseCarousel.querySelector('.showcase-track');
    const cards = showcaseCarousel.querySelectorAll('.showcase-card');
    const dots = showcaseCarousel.querySelectorAll('.showcase-dot');
    let currentShowcase = 0;
    let showcaseStartX = 0;
    let showcaseEndX = 0;

    function showShowcase(index) {
      const cardWidth = cards[0].offsetWidth;
      const gap = 16;
      const offset = -index * (cardWidth + gap);
      track.style.transform = `translateX(${offset}px)`;

      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
      });
      currentShowcase = index;
    }

    // Dot navigation
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        showShowcase(index);
      });
    });

    // Touch/swipe support
    track.addEventListener('touchstart', (e) => {
      showcaseStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    track.addEventListener('touchend', (e) => {
      showcaseEndX = e.changedTouches[0].screenX;
      const diff = showcaseStartX - showcaseEndX;
      const threshold = 50;

      if (Math.abs(diff) > threshold) {
        if (diff > 0 && currentShowcase < cards.length - 1) {
          showShowcase(currentShowcase + 1);
        } else if (diff < 0 && currentShowcase > 0) {
          showShowcase(currentShowcase - 1);
        }
      }
    });

    // Initialize
    showShowcase(0);

    // Recalculate on resize
    window.addEventListener('resize', () => {
      if (window.innerWidth <= 768) {
        showShowcase(currentShowcase);
      }
    });
  }
});

// ========== VIND JOUW MATCH - SPRING PHYSICS DRAG & SNAP ==========
(function() {
  const track = document.querySelector('.smellish-match__track');
  if (!track) return;

  const cards = track.querySelectorAll('.smellish-match__card');
  if (!cards.length) return;

  let isDown = false;
  let isDragged = false;
  let startX;
  let scrollLeft;
  let animId = null;

  // Velocity tracking
  let velSamples = [];

  // Spring parameters - licht overdamped voor soepel "terugvallen" zonder bounce
  const STIFFNESS = 80;     // Hoe sterk de spring trekt (lager = zachter)
  const DAMPING = 22;       // Demping (hoger = minder oscillatie)
  const MASS = 1;           // Virtuele massa
  const VELOCITY_SCALE = 1.2; // Hoe sterk drag-velocity doorwerkt in de spring

  // Snap posities berekenen
  function getSnapPositions() {
    const trackPad = parseFloat(getComputedStyle(track).paddingLeft) || 40;
    const positions = [];

    cards.forEach(function(card) {
      positions.push(card.offsetLeft - trackPad);
    });

    positions[0] = 0;
    return positions;
  }

  function findNearestSnap(targetScroll) {
    const positions = getSnapPositions();
    const maxScroll = track.scrollWidth - track.clientWidth;

    let nearest = positions[0];
    let minDist = Infinity;

    positions.forEach(function(pos) {
      var clamped = Math.max(0, Math.min(pos, maxScroll));
      var dist = Math.abs(targetScroll - clamped);
      if (dist < minDist) {
        minDist = dist;
        nearest = clamped;
      }
    });

    return Math.max(0, Math.min(nearest, maxScroll));
  }

  // Spring-physics animatie: positie en velocity evolueren continu
  // Voelt als een bal die in een kommetje rolt en tot stilstand komt
  function springToSnap(target, initialVelocity) {
    if (animId) cancelAnimationFrame(animId);

    var pos = track.scrollLeft;
    // initialVelocity is in px/ms (muis richting), omrekenen naar scroll richting (px/s)
    var vel = -initialVelocity * 1000 * VELOCITY_SCALE;
    var lastTime = performance.now();

    function step(now) {
      // Delta time in seconden, cap bij 32ms om grote sprongen te voorkomen
      var dt = Math.min((now - lastTime) / 1000, 0.032);
      lastTime = now;

      // Spring kracht: F = -k * displacement
      var displacement = pos - target;
      var springForce = -STIFFNESS * displacement;

      // Demping kracht: F = -d * velocity
      var dampingForce = -DAMPING * vel;

      // Newton: a = F/m
      var acceleration = (springForce + dampingForce) / MASS;

      // Euler integratie
      vel += acceleration * dt;
      pos += vel * dt;

      // Clamp binnen scroll grenzen
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (pos < 0) { pos = 0; vel = 0; }
      if (pos > maxScroll) { pos = maxScroll; vel = 0; }

      track.scrollLeft = pos;

      // Stop als beweging verwaarloosbaar is
      if (Math.abs(vel) < 0.3 && Math.abs(pos - target) < 0.5) {
        track.scrollLeft = target;
        animId = null;
        return;
      }

      animId = requestAnimationFrame(step);
    }

    animId = requestAnimationFrame(step);
  }

  // Bereken gemiddelde velocity uit laatste samples
  function getVelocity() {
    if (velSamples.length < 2) return 0;

    // Pak laatste 5 samples voor betere smoothing
    var recent = velSamples.slice(-5);
    var totalV = 0;
    var count = 0;
    for (var i = 1; i < recent.length; i++) {
      var dx = recent[i].x - recent[i-1].x;
      var dt = recent[i].t - recent[i-1].t;
      if (dt > 0) {
        totalV += dx / dt;
        count++;
      }
    }
    return count > 0 ? totalV / count : 0;
  }

  // --- Mouse events ---

  track.addEventListener('mousedown', function(e) {
    if (animId) { cancelAnimationFrame(animId); animId = null; }
    isDown = true;
    isDragged = false;
    track.classList.add('is-dragging');
    startX = e.pageX;
    scrollLeft = track.scrollLeft;
    velSamples = [{ x: e.pageX, t: performance.now() }];
    e.preventDefault();
  });

  track.addEventListener('mousemove', function(e) {
    if (!isDown) return;
    e.preventDefault();

    var dx = e.pageX - startX;
    if (Math.abs(dx) > 4) isDragged = true;

    // Direct 1:1 meebewegen met muis
    track.scrollLeft = scrollLeft - dx;

    // Sample opslaan voor velocity
    velSamples.push({ x: e.pageX, t: performance.now() });
    if (velSamples.length > 10) velSamples.shift();
  });

  function finishDrag() {
    if (!isDown) return;
    isDown = false;
    track.classList.remove('is-dragging');

    // Velocity: positief = muis naar rechts = scroll naar links
    var vel = getVelocity();

    // Project waar scroll heen gaat op basis van momentum
    var momentum = vel * 250;
    var projected = track.scrollLeft - momentum;

    // Dichtstbijzijnde snap punt
    var snapTarget = findNearestSnap(projected);

    // Spring animatie met initiële drag-velocity
    springToSnap(snapTarget, vel);
  }

  track.addEventListener('mouseup', function() { finishDrag(); });
  track.addEventListener('mouseleave', function() { finishDrag(); });

  // Prevent card clicks wanneer gesleept
  cards.forEach(function(card) {
    card.addEventListener('click', function(e) {
      if (isDragged) {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  });

  // --- Touch events: alleen op desktop/tablet (>767px) ---
  // Op mobiel (<=767px) gebruiken we native CSS scroll-snap (soepeler, 60fps)
  if (window.innerWidth > 767) {
    track.addEventListener('touchstart', function(e) {
      if (animId) { cancelAnimationFrame(animId); animId = null; }
      isDown = true;
      isDragged = false;
      startX = e.touches[0].pageX;
      scrollLeft = track.scrollLeft;
      velSamples = [{ x: e.touches[0].pageX, t: performance.now() }];
    }, { passive: true });

    track.addEventListener('touchmove', function(e) {
      if (!isDown) return;

      var dx = e.touches[0].pageX - startX;
      if (Math.abs(dx) > 4) isDragged = true;

      track.scrollLeft = scrollLeft - dx;

      velSamples.push({ x: e.touches[0].pageX, t: performance.now() });
      if (velSamples.length > 10) velSamples.shift();
    }, { passive: true });

    track.addEventListener('touchend', function() { finishDrag(); });
    track.addEventListener('touchcancel', function() { finishDrag(); });
  }
})();

// ========== SMELLISH QUIZ HERO SLIDER ==========
(function() {
  'use strict';

  const section = document.getElementById('smellishQuizHeroInline');
  if (!section) return;

  const slides = section.querySelectorAll('.sqh-slide');
  const dots = section.querySelectorAll('.sqh-dot');
  const sliderTrack = section.querySelector('.sqh-slider-track');

  if (slides.length <= 1) return;

  // Settings from data attributes
  const autoplay = section.dataset.autoplay === 'true';
  const interval = parseInt(section.dataset.interval, 10) || 6000;
  const transitionMs = parseInt(section.dataset.transition, 10) || 400;
  const pauseAfterClick = 10000; // 10 seconds pause after manual dot click

  // State
  let currentIndex = 0;
  const totalSlides = slides.length;
  let autoplayTimer = null;
  let isAnimating = false;

  // Touch state
  let touchStartX = 0;
  let touchEndX = 0;
  const touchThreshold = 50;

  // Reduced motion check
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const actualInterval = prefersReducedMotion ? 30000 : interval;

  // Restart progress ring animation
  function restartProgressRing(dotElement) {
    const progressCircle = dotElement.querySelector('.sqh-progress-ring__circle');
    if (progressCircle) {
      progressCircle.style.animation = 'none';
      progressCircle.offsetHeight; // Force reflow
      progressCircle.style.animation = '';
    }
  }

  function goToSlide(index, isManualClick = false) {
    if (isAnimating || index === currentIndex) return;
    if (index < 0) index = totalSlides - 1;
    if (index >= totalSlides) index = 0;

    isAnimating = true;

    const currentSlide = slides[currentIndex];
    const nextSlide = slides[index];

    currentSlide.classList.add('is-fading');
    currentSlide.classList.remove('is-active');
    currentSlide.setAttribute('aria-hidden', 'true');

    nextSlide.classList.add('is-active');
    nextSlide.setAttribute('aria-hidden', 'false');

    // Update dots and restart progress ring
    if (dots.length) {
      dots[currentIndex].classList.remove('is-active');
      dots[currentIndex].setAttribute('aria-selected', 'false');
      dots[index].classList.add('is-active');
      dots[index].setAttribute('aria-selected', 'true');
      restartProgressRing(dots[index]);
    }

    currentIndex = index;

    setTimeout(() => {
      currentSlide.classList.remove('is-fading');
      isAnimating = false;
    }, transitionMs);

    // Restart autoplay - with longer delay after manual click
    if (autoplay) {
      startAutoplay(isManualClick ? pauseAfterClick : actualInterval);
    }
  }

  function nextSlide() {
    goToSlide(currentIndex + 1, false);
  }

  function prevSlide() {
    goToSlide(currentIndex - 1, false);
  }

  function startAutoplay(customInterval = null) {
    stopAutoplay();
    const useInterval = customInterval || actualInterval;
    autoplayTimer = setInterval(nextSlide, useInterval);
  }

  function stopAutoplay() {
    if (autoplayTimer) {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  }

  // Dot navigation - manual click triggers 10 sec pause
  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => goToSlide(index, true));
  });

  // NO hover pause - autoplay runs continuously

  // Touch swipe
  if (sliderTrack) {
    sliderTrack.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    sliderTrack.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) > touchThreshold) {
        if (diff > 0) goToSlide(currentIndex + 1, true);
        else goToSlide(currentIndex - 1, true);
      }
    }, { passive: true });
  }

  // Initialize first dot progress ring
  if (dots[0]) {
    restartProgressRing(dots[0]);
  }

  // Start autoplay - runs continuously, never stops
  if (autoplay) startAutoplay();
})();
